<template>
  <div>
    <section>
      <div class="container">
        <h1 class="admin-page">Empresas cliente</h1>
        <div class="pull-right" style="margin-top: 1em;">
          <router-link to="/proveedoresform" class="btn btn-fill">Nuevo</router-link>
        </div>
        <div class="row">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Dirección</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="proveedor in proveedores" :key="proveedor._id">
                <td>{{proveedor.razonSocial}}</td>
                <td>{{proveedor.direccion}}</td>
                <td>
                  <div class="button-group">
                    <ul class="table-actions smart-form">
                      <li>
                        <router-link :to="`/proveedoresform/edit/${proveedor._id}`" class="btn btn-xs btn-ghost" type="button">
                          <i class="fa fa-actions fa-edit"></i>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      proveedores: []
    }
  },
  mounted () {
    const me = this
    me.$http.get('/api/admin/proveedores').then(({body}) => {
      me.proveedores = body.proveedores
    }, (err) => {
      console.error(err)
    })
  }
}
</script>



// WEBPACK FOOTER //
// Lista.vue?5c67c96a